<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Most basic usage</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <knob-control :value="34"></knob-control>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Specifying minimum and maximum</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <knob-control
              :min="-12"
              :max="12"
              :stroke-width="8"
              :value="-3"
            ></knob-control>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Changing size and colors:</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <knob-control
              :min="-64"
              :max="63"
              :size="75"
              primary-color="#E844C3"
              secondary-color="#E7B6DC"
              text-color="#E844C3"
              :value="7"
            ></knob-control>
          </div>
        </div>
      </vs-col>
   
    </div>
  </div>
</template>
<script>
import KnobControl from "vue-knob-control";

export default {
  components: {
    KnobControl,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
    return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  }
};
</script>